import {styled} from "@mui/material/styles"

export type GradientProps = {
    flip: boolean
    isShown: boolean
    isTouchDevice: boolean
}

const gradientLeftMargin = (flip: boolean, isTouchDevice: boolean) => {
    if (flip) {
        if (isTouchDevice) {
            return "-1rem"
        }
        return "-2rem"
    }
    return "0"
}

const gradientRightMargin = (flip: boolean, isTouchDevice: boolean) => {
    if (flip) return "0"
    if (isTouchDevice) {
        return "-1rem"
    }
    return "-2rem"
}

export const Gradient = styled("div", {
    shouldForwardProp: prop => !["isShown", "isTouchDevice", "flip"].includes(prop as string),
})<GradientProps>`
    transition: width 0.15s;
    z-index: 3;
    width: ${({isShown}) => (isShown ? "1rem" : "0")};
    height: 1rem;
    transform: rotateZ(${({flip}) => (flip ? "180deg" : "0")});
    margin-left: ${props => gradientLeftMargin(props.flip, props.isTouchDevice)};
    margin-right: ${props => gradientRightMargin(props.flip, props.isTouchDevice)};
`
export type ContainerProps = {doRotate: boolean}
export const Container = styled("div", {
    shouldForwardProp: prop => prop !== "doRotate",
})<ContainerProps>`
    pointer-events: none;
    width: 1rem;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    transform: rotateY(${({doRotate}) => (doRotate ? "180deg" : "0")});
    z-index: 3;
    && button {
        pointer-events: auto;
        width: 1.5rem;
        border-radius: 0;
        height: 100%;
        padding: 0;
        span:first-of-type {
            width: auto;
        }
        background: ${({theme}) => theme.uxfabric.components.appBar.navBar.default.backgroundColor};
    }
`
